import React from "react";

const SchemaRenalTransplant = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Is kidney transplant better than dialysis?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. For eligible patients, a kidney transplant generally offers longer survival, improved quality of life, better energy levels, and fewer dietary restrictions compared to long-term dialysis."
                }
            },
            {
                "@type": "Question",
                "name": "What is the success rate of renal transplant?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "With experienced transplant surgeons, advanced infrastructure, and proper post-operative care, renal transplant success rates are significantly high. Long-term outcomes depend on patient health, donor compatibility, and adherence to medications."
                }
            },
            {
                "@type": "Question",
                "name": "How long does recovery take after a kidney transplant?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Most patients stay in the hospital for 1 to 2 weeks. Full recovery may take a few weeks to a few months depending on overall health and response to treatment. Regular follow-ups are essential during recovery."
                }
            },
            {
                "@type": "Question",
                "name": "Who is eligible for a renal transplant?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You may be eligible if you have end-stage renal disease, are medically fit for surgery, have a compatible donor available, and do not have active infections or uncontrolled medical conditions."
                }
            },
            {
                "@type": "Question",
                "name": "What types of kidney transplants are available at HDNA Aarogyam Hospital?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We perform living donor kidney transplant and deceased donor kidney transplant. Both procedures follow strict ethical, legal, and medical guidelines."
                }
            },
            {
                "@type": "Question",
                "name": "How long does the kidney transplant surgery take?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The surgical procedure typically takes around 3 to 4 hours. However, total hospital time depends on post-operative monitoring and recovery progress."
                }
            },
            {
                "@type": "Question",
                "name": "What tests are required before a kidney transplant?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Pre-transplant evaluation includes blood tests, tissue typing, cross-matching, imaging studies, cardiac evaluation, and overall health screening for both donor and recipient."
                }
            },
            {
                "@type": "Question",
                "name": "What is the cost of kidney transplant in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The cost depends on factors such as type of transplant, patient condition, hospital stay duration, and post-surgical medications. HDNA Aarogyam Hospital provides transparent cost guidance and insurance assistance."
                }
            },
            {
                "@type": "Question",
                "name": "Will I need lifelong medication after a kidney transplant?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. Patients must take immunosuppressive medications for life to prevent organ rejection. Regular follow-up visits and kidney function tests are essential for long-term success."
                }
            },
            {
                "@type": "Question",
                "name": "What are the risks associated with kidney transplantation?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Like any major surgery, kidney transplantation carries risks such as infection, bleeding, or organ rejection. However, with advanced ICU care, strict infection control, and expert supervision, risks are significantly minimized."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
};

export default SchemaRenalTransplant;
